import { AxiosRequestConfig } from "axios";
import { useRestService } from "./use-rest-service";
import { METHOD, REPORTS_ORDERS_ITEMS, REPORTS_ORDERS_SUMMARY } from "../../constants/requests";

export const useOrderReportHandler = () => {
  const { executeRequest } = useRestService();

  const orderSummary = (startDate: string, endDate: string, storeId: string) => {
    const params: any = {
      startDate,
      endDate,
      storeId,
      responseType: "csv",
    };

    const requestOptions: AxiosRequestConfig = {
      method: METHOD.GET,
      url: REPORTS_ORDERS_SUMMARY,
      params: params,
      headers: {
        "Cache-Control": "no-cache",
      },
    };
    return executeRequest(requestOptions);
  };

  const orderItems = (startDate: string, endDate: string, storeId: string) => {
    const params: any = {
      startDate,
      endDate,
      storeId,
      responseType: "csv",
    };

    const requestOptions: AxiosRequestConfig = {
      method: METHOD.GET,
      url: REPORTS_ORDERS_ITEMS,
      params: params,
      headers: {
        "Cache-Control": "no-cache",
      },
    };
    return executeRequest(requestOptions);
  };

  return {
    orderSummary,
    orderItems,
  };
};
